import React, { useEffect, useState, createContext, useContext } from 'react';
import { useAuthContext } from '../auth/AuthContext';
import { onUserSnapshot } from '../../repository/UserDAO';
import { useTheme } from '../theme_context/ThemeContext';
import { UserStatus } from '../../components/routes/routing_statuses/RoutingStatuses';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { user } = useAuthContext()
  const [firebaseUser, setFirebaseUser] = useState(UserStatus.UNINITIALIZED);
  const [userEnabledFeatures, setUserEnabledFeatures] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const { setThemeMode } = useTheme();

  // Helper function to clear user state
  const clearState = () => {
    setFirebaseUser(UserStatus.UNINITIALIZED);
    setUserRole();
  };

  useEffect(() => {
    let unsubscribe = null;
    
    if (user) {
      // Pass state setters directly to the DAO
      unsubscribe = onUserSnapshot(
        user.uid, 
        null, // No callback needed since we're using direct state setters
        { setFirebaseUser, setUserRole, setThemeMode }
      );
    } else {
      clearState();
    }

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [user, setFirebaseUser, setUserRole, setThemeMode]);

  const resetUserContext = () => {
    setFirebaseUser(UserStatus.UNINITIALIZED);
    setUserEnabledFeatures([]);
    setUserRole(null);
  };

  return (
    <UserContext.Provider value={{ firebaseUser, userEnabledFeatures, userRole, resetUserContext }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  return useContext(UserContext);
};
